"use strict";

/*
 ## External Dependencies ##
  - jQuery ($)
 */

var cx = require("classnames");

var Popover = React.createClass({
  componentDidMount: function(){
    var wrapper = this.refs.wrapper;
    $(wrapper).on("hide.bs.dropdown", this.onClose);
  },
  notifyChildrenOnClose: function () {
    var index = 0;
    React.Children.forEach(this.props.children, function (obj) {
      var child = this.refs["child-" + index++];
      if (child.onParentClose) {
        child.onParentClose();
      }
    }.bind(this));
  },
  onClose: function () {
    var popover = this.refs.popover;
    var shouldClose = (!$(popover).is(":hover"));

    if(shouldClose){
      if (this.props.onClose) {
        this.props.onClose();
      }
      this.notifyChildrenOnClose();
    }

    return shouldClose;
  },
  close: function(){
    var wrapper = this.refs.wrapper;
    $(wrapper).removeClass("open");
  },
  getHydratedChildrenWithProps: function () {
    var index = 0;
    return React.Children.map(this.props.children, function(child){
      return React.cloneElement(child, {
        closeParentElem: this.close,
        ref: "child-" + index++
      });
    }, this);
  },
  render: function() {
    var trigger = this.props.trigger;
    var triggerExtraProps = {
      "data-toggle": "dropdown",
      className: cx(trigger.props.className, "dropdown-toggle")
    };

    var classes = cx(
      this.props.classes,
      "dropdown-menu"
    );

    return (
      <div className={this.props.wrapperClasses} ref="wrapper">
        {React.cloneElement(trigger, triggerExtraProps)}
        <div className={classes} role="menu" ref="popover">
          {this.getHydratedChildrenWithProps()}
        </div>
      </div>
    );
  }
});

module.exports = Popover;



// WEBPACK FOOTER //
// ./app/shared/components/Popover/popover.jsx